// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCard_card__3B3iB","preview":"NewsCard_preview__3sKVq","active":"NewsCard_active__204_O"};